import axios from "axios";
import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import "../style/collection.css";

function Collection() {
  const baseURL = process.env.REACT_APP_BASE_URL;

  let navigate = useNavigate();
  const [collection, setCollection] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseURL}/collection`)
      .then((response) => {
        setCollection(response.data);
      })
      .catch((error) => {
        console.error("Error fetching product:", error);
      });

    // User name and email should only be sent to this side
  }, []);

  function changeLocation(placeToGo) {
    navigate(placeToGo, { replace: true });
    window.location.reload();
  }

  return (
    <div className="Collection">
      <Link to={"/catalogue?search=all"} className="no-underline">
        <h1>All Items</h1>
      </Link>

      {/*  */}

      <div className="collectGrid">
        {collection.length > 0 ? (
          collection.slice(0, -2).map((category) => (
            <div
              key={category.collect_id} // Add a unique key if you're mapping
              style={{
                position: "relative",
                backgroundImage: `url(${category.collect_img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                overflow: "hidden",
              }}
              onClick={() =>
                changeLocation(
                  `/catalogue?page=${
                    category.collect_id
                  }&collect=${encodeURIComponent(category.collect_name)}`
                )
              }
            >
              {/* Gray overlay with opacity */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background:
                    "linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.5))",
                  opacity: 1,
                  zIndex: 1,
                }}
              ></div>

              {/* Text content above overlay */}
              <div
                style={{
                  position: "relative",
                  zIndex: 2,
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  fontWeight: "bold",
                }}
              >
                {category.collect_name}
              </div>
            </div>
          ))
        ) : (
          <i>
            No products in this shot — the roll might’ve jammed. Refresh to
            reload!
          </i>
        )}

        {/* Second part: only the last two items */}
        {collection.slice(-2).map((category) => (
          <a
            href={category.collect_link}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <div
              key={category.collect_id}
              style={{
                position: "relative",
                backgroundImage: `url(${category.collect_img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                overflow: "hidden",
              }}
            >
              {/* Gray overlay with opacity */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background:
                    "linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.5))",
                  opacity: 1,
                  zIndex: 1,
                }}
              ></div>

              {/* Text content above overlay */}
              <div
                style={{
                  position: "relative",
                  zIndex: 2,
                  color: "#fff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  fontWeight: "bold",
                }}
              >
                {category.collect_name}
              </div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default Collection;
